import React from 'react';
import { Link as RouterLink, useLocation, useNavigate, useParams } from 'react-router-dom';
import query from '../helpers/query';

export const Link = ({ to, query: queryProp, children, ...props }) => {
    let href = to;

    if (queryProp) {
        const qs = query.stringify(queryProp);
        if (qs) {
            href = to + (to.includes('?') ? '&' : '?') + qs;
        }
    }

    return (
        <RouterLink to={href} {...props}>
            {children}
        </RouterLink>
    );
};

export const withRouter = (Component) => {
    return (props) => {
        const location = useLocation();
        const navigate = useNavigate();
        const params = useParams();

        const locationWithQuery = { ...location, query: query.parseSearch(location.search) };

        const routerProps = {
            location: locationWithQuery,
            history: {
                push: (path) => navigate(path),
                replace: (path) => navigate(path, { replace: true }),
                go: (n) => navigate(n),
                goBack: () => navigate(-1),
                goForward: () => navigate(1),
                location: locationWithQuery
            },
            params,
            match: {
                params,
                path: location.pathname,
                url: location.pathname
            }
        };

        return <Component {...props} {...routerProps} />;
    };
};

export default { Link, withRouter };
